import axios from 'axios'
import { resolveAuthHeaderValue } from '@/utils/authToken'
import { apiUrl } from '@/utils/appConfig'

const adminApiClient = axios.create({
  baseURL: apiUrl(),
})

adminApiClient.interceptors.request.use(config => {
  const nextConfig = { ...config }
  const authHeaderValue = resolveAuthHeaderValue()
  if (!authHeaderValue) return nextConfig
  if (!nextConfig.headers) nextConfig.headers = {}
  nextConfig.headers.Authorization = authHeaderValue
  return nextConfig
})

export default adminApiClient
